const parentMenuItem = document.querySelector('.current-menu-ancestor')

if (parentMenuItem) {
    const subMenu = parentMenuItem.querySelector('.sub-menu')
    if (subMenu) {
        subMenu.classList.add('show')
    }
}